'use client'

import { cn } from '@/core/lib/utils/cn'
import { Bell, Heart, MapPin, ShoppingBasket, User } from 'lucide-react'
import Link from 'next/link'
import { Search } from './search'
import { useAuth } from '@/core/store/auth'
import { Skeleton } from '../atoms/skeleton'
import { useTranslations } from 'next-intl'
import { ROUTES } from '@/core/constants/routes'
import { LocaleSwitcher } from './locale-switch'

type Props = {
  className?: string
  store_address: string
  onNavigate?: () => void
}

export const NavLinks: React.FC<Props> = ({
  className,
  store_address,
  onNavigate,
}) => {
  const { isAuthenticated, user } = useAuth()
  const t = useTranslations()
  return (
    <div
      className={cn(
        'flex w-full max-w-4xl flex-1 items-center justify-center gap-4',
        className,
      )}
    >
      <div className='flex flex-col items-center justify-start gap-4 sm:flex-1 md:flex-row'>
        <div className='text-mountain-bluebird flex items-center text-sm whitespace-nowrap'>
          <MapPin className='mr-2 h-5 w-5' />
          {store_address && store_address.length > 0 ? (
            <span>
              {t('header.sendTo')} {store_address}
            </span>
          ) : (
            <Skeleton width='100px' height='21px' borderRadius='0.375rem' />
          )}
        </div>
        <Search />
        <LocaleSwitcher />
      </div>

      <div className='text-mountain-bluebird flex items-center gap-3'>
        {isAuthenticated ? (
          <>
            <Link
              href='/favorites'
              className='cursor-pointer rounded-full p-2 transition-colors duration-200'
              onClick={onNavigate}
            >
              <Heart
                className={cn(
                  'hover:text-creamed-cron h-6 w-6 transition-colors duration-300',
                )}
              />
            </Link>
            <Link
              onClick={onNavigate}
              href='/notifications'
              className={`after:bg-cyan-blue ${user?.hasUnreadNotifications ? `after:block` : `after:hidden`} relative cursor-pointer rounded-full p-2 transition-colors duration-200 after:absolute after:top-1 after:right-2.5 after:h-2.5 after:w-2.5 after:rounded-full after:content-['']`}
            >
              <Bell
                className={cn(
                  'hover:text-creamed-cron h-6 w-6 transition-colors duration-300',
                )}
              />
            </Link>
            <Link
              onClick={onNavigate}
              href='/cart'
              className='cursor-pointer rounded-full p-2 transition-colors duration-200'
            >
              <ShoppingBasket
                className={cn(
                  'hover:text-creamed-cron h-6 w-6 transition-colors duration-300',
                )}
              />
            </Link>
          </>
        ) : (
          <Link
            href={ROUTES.language}
            className='cursor-pointer rounded-full p-2 transition-colors duration-200'
          >
            <User
              className={cn(
                'hover:text-creamed-cron h-6 w-6 transition-colors duration-300',
              )}
            />
          </Link>
        )}
      </div>
    </div>
  )
}
